interface LoaderProps {
  height?: string;
  width?: string;
  margin?: string;
  borderRadius?: string;
  bars?: number;
  backgroundColor?: string;
  invertDefaultColors?: boolean;
}
export const Loader = ({
  bars = 5,
  height = "20px",
  width = "4px",
  margin = "1px",
  borderRadius = "2px",
  backgroundColor,
  invertDefaultColors,
}: LoaderProps) => {
  const getStyle = (i: number): React.CSSProperties => {
    return {
      backgroundColor:
        backgroundColor ||
        (invertDefaultColors
          ? "hsl(var(--primary-foreground))"
          : "hsl(var(--primary))"),
      width: width,
      height: height,
      margin: margin,
      borderRadius: borderRadius,
      display: "inline-block",
      animation: `loader ${bars * 0.2}s ${
        i * 0.1
      }s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)`,
      animationFillMode: "both",
    };
  };

  return (
    <span style={{ display: "inherit" }}>
      {Array.from({ length: bars }).map((_, i) => {
        return <span key={i} style={getStyle(i + 1)} />;
      })}
    </span>
  );
};
